import { render, staticRenderFns } from "./EditCategoryEquipmentPage.vue?vue&type=template&id=6b45d931"
import script from "./EditCategoryEquipmentPage.vue?vue&type=script&lang=js"
export * from "./EditCategoryEquipmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports